// import React, { useState, useEffect } from "react";
// import UserNavbar from "../../components/common/UserNavbar";
// import { Navigate } from "react-router-dom";
// import UserFooter from "../../components/common/UserFooter";
// import { FaWhatsapp } from "react-icons/fa6";
// import { FaRobot } from "react-icons/fa";
// import ChatBot from "../../components/common/Chatbot";
// import ContactModal from "../../components/User/Home/ContactModal";
// import WhatsAppChat from "../../components/common/Whatsapp";
// import ugcimage from "../../Assets/ugc.webp";

// const UserLayout = (props) => {
//   const [isChatBotOpen, setIsChatBotOpen] = useState(false);
//   const [isContactModalOpen, setIsContactModalOpen] = useState(false);
//   const [isUgcPopupOpen, setIsUgcPopupOpen] = useState(false);

//   useEffect(() => {
//     const timer = setTimeout(() => {
//       setIsContactModalOpen(true);
//     }, 1500);

//     return () => clearTimeout(timer);
//   }, []);

//   useEffect(() => {
//     const timer = setTimeout(() => {
//       setIsUgcPopupOpen(true);
//     }, 500);

//     return () => clearTimeout(timer);
//   }, []);

//   const ChatBotButton = () => {
//     return (
//       <>
//         <button
//           onClick={() => setIsChatBotOpen(true)}
//           className="blink-scale-button fixed right-6 bottom-16 w-14 h-14
//                    bg-gradient-to-r from-[#DA3335] to-[#144982]
//                    rounded-full shadow-2xl flex items-center justify-center
//                    hover:scale-110 transition-all duration-300 ease-in-out
//                    focus:outline-none border-2 border-[#DA3335] z-40"
//         >
//           <FaRobot size={28} className="text-white" />
//         </button>

//         <style>
//           {`
//           @keyframes blinkScale {
//             0%, 100% {
//               transform: scale(1);
//               opacity: 1;
//               box-shadow: 0 0 0 0 rgba(218, 51, 53, 0.7);
//             }
//             50% {
//               transform: scale(1.1);
//               opacity: 0.9;
//               box-shadow: 0 0 0 10px rgba(20, 73, 130, 0.3);
//             }
//           }

//           .blink-scale-button {
//             animation: blinkScale 2s infinite;
//           }

//           .blink-scale-button:hover {
//             animation: none;
//             transform: scale(1.1);
//           }
//         `}
//         </style>
//       </>
//     );
//   };

//   const UgcPopup = () => {
//     if (!isUgcPopupOpen) return null;

//     return (
//       <div className="fixed left-4 top-32 md:left-6 md:top-36 z-40 animate-fade-in-down">
//         <button
//           // onClick={() => setIsUgcPopupOpen(false)}
//           className="relative group"
//           aria-label="Close UGC badge"
//         >
//           <img
//             src={ugcimage}
//             alt="UGC Approved"
//             className="w-16 h-16 md:w-36 md:h-36 object-contain drop-shadow-xl
//                      hover:scale-110 transition-transform duration-300"
//           />
//           {/* <span
//             className="absolute -top-1 -right-1 w-5 h-5 rounded-full bg-black/60
//                      text-white text-xs items-center justify-center
//                      opacity-0 group-hover:opacity-100 transition-opacity duration-200
//                      hidden md:flex"
//           >
//             ✕
//           </span> */}
//         </button>

//         <style>
//           {`
//             @keyframes fadeInDown {
//               from {
//                 opacity: 0;
//                 transform: translateY(-20px);
//               }
//               to {
//                 opacity: 1;
//                 transform: translateY(0);
//               }
//             }
//             .animate-fade-in-down {
//               animation: fadeInDown 0.4s ease-out;
//             }
//           `}
//         </style>
//       </div>
//     );
//   };

//   return (
//     <React.Fragment>
//       <UserNavbar />

//       <UgcPopup />

//       {props.children}
//       <UserFooter />

//       <ChatBotButton />

//       <WhatsAppChat />

//       {isChatBotOpen && <ChatBot onClose={() => setIsChatBotOpen(false)} />}

//       <ContactModal
//         isOpen={isContactModalOpen}
//         onClose={() => setIsContactModalOpen(false)}
//       />
//     </React.Fragment>
//   );
// };

// export default UserLayout;

import React, { useState, useEffect } from "react";
import UserNavbar from "../../components/common/UserNavbar";
import { Navigate } from "react-router-dom";
import UserFooter from "../../components/common/UserFooter";
import { FaWhatsapp } from "react-icons/fa6";
import { FaRobot } from "react-icons/fa";
import ChatBot from "../../components/common/Chatbot";
import ContactModal from "../../components/User/Home/ContactModal";
import WhatsAppChat from "../../components/common/Whatsapp";
import ugcimage from "../../Assets/ugc.webp";

const UserLayout = (props) => {
  const [isChatBotOpen, setIsChatBotOpen] = useState(false);
  const [isContactModalOpen, setIsContactModalOpen] = useState(false);

  useEffect(() => {
    const timer = setTimeout(() => {
      setIsContactModalOpen(true);
    }, 1500);

    return () => clearTimeout(timer);
  }, []);

  const ChatBotButton = () => {
    return (
      <>
        <button
          onClick={() => setIsChatBotOpen(true)}
          className="blink-scale-button fixed right-6 bottom-16 w-14 h-14
                   bg-gradient-to-r from-[#DA3335] to-[#144982]
                   rounded-full shadow-2xl flex items-center justify-center
                   hover:scale-110 transition-all duration-300 ease-in-out
                   focus:outline-none border-2 border-[#DA3335] z-40"
        >
          <FaRobot size={28} className="text-white" />
        </button>

        <style>
          {`
          @keyframes blinkScale {
            0%, 100% {
              transform: scale(1);
              opacity: 1;
              box-shadow: 0 0 0 0 rgba(218, 51, 53, 0.7);
            }
            50% {
              transform: scale(1.1);
              opacity: 0.9;
              box-shadow: 0 0 0 10px rgba(20, 73, 130, 0.3);
            }
          }

          .blink-scale-button {
            animation: blinkScale 2s infinite;
          }

          .blink-scale-button:hover {
            animation: none;
            transform: scale(1.1);
          }
        `}
        </style>
      </>
    );
  };

  return (
    <React.Fragment>
      <UserNavbar />
      {props.children}
      <UserFooter />

      <ChatBotButton />

      <WhatsAppChat />

      {isChatBotOpen && <ChatBot onClose={() => setIsChatBotOpen(false)} />}

      <ContactModal
        isOpen={isContactModalOpen}
        onClose={() => setIsContactModalOpen(false)}
      />
    </React.Fragment>
  );
};

export default UserLayout;
